import React, { useContext, useState, useEffect } from 'react'
import { Alert, Button, Col, Container, Fade, Form, Image, Row } from 'react-bootstrap'
import logo from '../../assets/app-logo.png';
import { AuthContext } from '../../context/AuthContext';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// Import Firestore functions and db instance
import { db } from '../../firebase/firebase'; 
import { collection, addDoc, serverTimestamp } from "firebase/firestore"; 
// Import the specific CSS for this component
import './QueryFrom.css';


const QueryForm = () => {
    const location = useLocation(); // Get location object
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [queryType, setQueryType] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); // State to handle submission status
    const [submitted, setSubmitted] = useState(false); // Show confirmation panel after a successful submit
    const navigate = useNavigate();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const typeFromUrl = searchParams.get('type');
        if (typeFromUrl) {
            setQueryType(typeFromUrl); // Set queryType from URL parameter
        }
    }, [location]); // Re-run effect if location changes

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return; // Prevent double submission
        setError('');

        if (!name.trim()) {
            setError('Name is required.');
            return;
        }
        if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        if (!queryType) {
            setError('Please select a query type.');
            return;
        }
        if (message.length < 10) {
            setError('Message must be at least 10 characters long.');
            return;
        }

        setIsSubmitting(true);

        try {
            // Get a reference to the queries collection
            const queriesCollectionRef = collection(db, "queries");

            // Data to save
            const queryData = {
                name: name,
                email: email,
                queryType: queryType,
                message: message,
                submittedAt: serverTimestamp(), // Add a server timestamp
                status: 'new' // Optional: Add a default status
            };

            // Add the document to Firestore
            await addDoc(queriesCollectionRef, queryData);

            console.log("Query successfully submitted to Firestore.");
            // Clear the form and show the confirmation panel (stay on /query)
            setName('');
            setEmail('');
            setQueryType('');
            setMessage('');
            setSubmitted(true);

        } catch (err) {
            setError(err.message || 'Query submission failed. Please try again.');
            console.error("Firestore submission error:", err);
        } finally {
            setIsSubmitting(false); // Re-enable submit button
        }
    };

    return (
        <>
            <main id="main-content" className="query-page-container">
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10} md={8} lg={6}>
                            <Link to="/" className="d-inline-block">
                                <Image src={logo} alt="Right Spade — go to homepage" className='mb-3 ms-4 ms-md-0' />
                            </Link>
                            <Fade direction="up" cascade damping={0.1}>
                                <div className="query-form-wrapper">
                                    {submitted ? (
                                        <div className="query-confirmation text-center">
                                            <Alert variant="success" className="mb-4">
                                                Thank you for contacting Right Spade. We have received your request successfully. Our team will review the details and get back to you within the next 48 business hours.
                                            </Alert>
                                            <Button as={Link} to="/" className="register-button">
                                                Back to Home
                                            </Button>
                                        </div>
                                    ) : (
                                        <>
                                            {error && <Alert variant="danger">{error}</Alert>}
                                            <Form onSubmit={handleSubmit}>
                                                <Form.Group className="mb-3" controlId="formQueryName">
                                                    <Form.Label>Name</Form.Label>
                                                    <Form.Control
                                                      type="text"
                                                      placeholder="Enter your Name"
                                                      value={name}
                                                      onChange={(e) => setName(e.target.value)}
                                                      required
                                                      disabled={isSubmitting}
                                                      aria-describedby="nameHelpBlock"
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formQueryEmail">
                                                    <Form.Label>E-mail</Form.Label>
                                                    <Form.Control
                                                      type="email"
                                                      placeholder="Enter your email address"
                                                      value={email}
                                                      onChange={(e) => setEmail(e.target.value)}
                                                      required
                                                      disabled={isSubmitting}
                                                      aria-describedby="emailHelpBlock"
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formQueryType">
                                                    <Form.Label>Query</Form.Label>
                                                    <Form.Select
                                                        className='select'
                                                        value={queryType}
                                                        onChange={(e) => setQueryType(e.target.value)}
                                                        required
                                                        disabled={isSubmitting}
                                                        aria-describedby="queryHelpBlock"
                                                    >
                                                        <option value="" disabled>Choose from the list</option>
                                                        <option value="subscriptionAccess">Subscription & Access</option>
                                                        <option value="clarificationResearchSupport">Clarification on research support</option>
                                                        <option value="kycAccountActivation">KYC & Account activation support</option>
                                                        <option value="paymentInvoiceQueries">Payment & Invoice queries</option>
                                                        <option value="platformNavigationTechnicalHelp">Platform navigation / Technical help</option>
                                                        <option value="investorFeedbackSuggestion">Investor Feedback & suggestions</option>
                                                        <option value="grievance">Accessibility & Grievance Redressal</option>
                                                        <option value="other">Other / Not listed above</option>
                                                    </Form.Select>
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formQueryMessage">
                                                    <Form.Label>Message</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={5}
                                                        placeholder="Enter your message here"
                                                        value={message}
                                                        onChange={(e) => setMessage(e.target.value)}
                                                        required
                                                        disabled={isSubmitting}
                                                        aria-describedby="messageHelpBlock"
                                                    />
                                                </Form.Group>

                                                <Button type="submit" className="register-button mb-1" disabled={isSubmitting}>
                                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                                </Button>
                                            </Form>
                                        </>
                                    )}
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </Container>
            </main>
        </>
    )
}

export default QueryForm